module.exports = __webpack_public_path__ + "media/images/expert-slide1-137c669490cc9bba54742a4b16a131457e2aeb6e248337789e9b54a409f563f4.jpg";